export default "__VITE_ASSET__b75890bf__"